module.exports = __webpack_public_path__ + "img/badge_appaga.2b8a2eff.jpg";